'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shortid/lib/util/cluster-worker-id-browser.js
// module id = 1913
// module chunks = 0